<template>
  <form-shell
    :title="$t('title')"
    :formsOnShell="formsOnShell"
    :successTexts="successTexts"
    :callbackRequest="createPhysicalWorldSwapOrder"
    :makeBodyToRequest="makeBodyToRequest"
    @cancel="handleCancel"
  ></form-shell>
</template>
<script>
import { mapActions } from 'vuex'

import FormShell from '@/views/PhysicalWorld/components/FormShell.vue'
import { TERMINAL_ROUTES_ENUM } from '@/enums/physical-world.enum'

import PhysicalWorldManager from '../physical-world.manager'
import {
  FORM_ADDRESS,
  FORM_RECEIVERS,
  FORM_OPEN_HOURS,
  FORM_OBSERVATION
} from './forms-context-terminals.enum'

export default {
  name: 'TerminalSwapRequest',
  components: {
    FormShell
  },
  data () {
    return {
      formsOnShell: [
        {
          name: 'formTerminalData',
          disabled: true,
          fields: ['serialNumber'],
          initialValues: {
            serialNumber: this.$route?.params.serialNumber
          }
        },
        FORM_ADDRESS,
        FORM_RECEIVERS,
        FORM_OBSERVATION,
        FORM_OPEN_HOURS
      ],
      successTexts: {
        title: this.$t('success.title'),
        info: this.$t('success.info'),
        content: this.$t('success.content')
      }
    }
  },
  methods: {
    ...mapActions({
      createPhysicalWorldSwapOrder: 'CREATE_PHYSICAL_WORLD_SWAP_ORDER'
    }),
    makeBodyToRequest () {
      return new PhysicalWorldManager().makeBodyToRequestSwapTerminal()
    },
    handleCancel () {
      this.$router.push({ name: TERMINAL_ROUTES_ENUM.TERMINALS })
    }
  }
}
</script>
<i18n>
  {
    "pt-BR": {
      "title": "Substituição de Maquininha",
      "button": {
        "submit": "Solicitar"
      },
      "success": {
        "title": "Substituição de Maquininha",
        "info": "Substituição solicitada com sucesso",
        "content": "Ao clicar no botão abaixo, você será encaminhado para listagem de ordens de serviço para acompanhar sua solicitação."
      }
    },
    "en-US": {
      "title": "Request Swap",
      "button": {
        "submit": "Request"
      },
      "success": {
        "title": "Request Swap",
        "info": "Swap requested successfully",
        "content": "By clicking the button below, you will be redirected to the service order list to track your request."
      }
    }
  }
</i18n>
